import {__} from "./__";

export const getAiTypes = () => {
    return {
        creative: __('Kreatívny - vhodné na tvorbu nápadov, písanie príbehov'),
        formal: __('Formálny / faktický - precízne, vecné odpovede'),
        antiformal: __('Rozhovorový - neformálne, prirodzené odpovede'),
        technic: __('Technický expert - technické, konzistentné odpovede'),
        explorer: __('Zvedavý prieskumník - kreatívne a rôznorodé témy'),
        minimalist: __('Minimalista - stručné, jasné odpovede'),
        repetitive: __('Repetitívny - bez obmedzení, pre testovanie opakovaní'),
        poet: __('Odvážny básnik - experimentálne, lyrické odpovede'),
        brainstorming: __('Brainstorming partner - pomoc pri hľadaní nápadov'),
        answers: __('Stroj na odpovede - rýchle, faktické, bez opakovania'),
    };
};
